import { Switch } from "react-router-dom";
import AnunciosListaPage from "./Listagem";
import AnaliseAnuncio from "./Detalhes/AnaliseAnuncio";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "core/resources/enums/permissao";

function AnunciosPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/administracao/anuncios"
        permissions={[PermissaoEnum.Backoffice.Administrativo.Anuncio.Visualizar]}
        component={AnunciosListaPage}
      />

      <AuthRoute
        exact
        path="/administracao/anuncios/:id"
        permissions={[PermissaoEnum.Backoffice.Administrativo.Anuncio.Visualizar]}
        component={AnaliseAnuncio}
      />
    </Switch>
  );
}

export default AnunciosPages;
